export function getApiError(err: any, fallback: string): string {
    const res = err?.response;
    if (!res) {
      return 'Cannot reach the server. Check your internet connection and try again.';
    }
    if (res.status === 401) return 'Your session has expired. Please log in again.';
    if (res.status === 413) {
      return 'Upload too large. Reduce the number or size of photos and try again.';
    }
    if (res.status >= 500) {
      return `Server error (HTTP ${res.status}). Please try again; report it if it keeps happening.`;
    }
    const data = res.data;
    if (Array.isArray(data)) return data.join(' ');
    if (data && typeof data === 'object') {
      if (data.error) return String(data.error);
      if (Array.isArray(data.errors)) return data.errors.join(' ');
      if (data.detail) return String(data.detail);
      const parts = Object.entries(data).map(
        ([k, v]) => `${k}: ${Array.isArray(v) ? v.join(' ') : String(v)}`
      );
      if (parts.length) return parts.join(' | ');
    }
    return `${fallback} (HTTP ${res.status})`;
  }